import React from 'react';
import './styles/ThemeSwitcher.css';

export const ThemeSwitcher: React.FC = () => {
  return null;
};
